import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/factories')({
  staticData: { section: 'Settings', breadcrumb: 'Factory Admin' },
  component: () => <Outlet />,
});
